<template>
    <div fluid class="mb-4 background-container admin-home">
      <b-row>
        <div class="collections-selection background-container">
          <div class="container background-container">
            <h5 class="text-left mt-2 mb-3 pl-3">Devices</h5>
            <div class="collections-list pl-2 pr-0">
              <div
                v-for="device in devices"
                :key="device"
                class="media user-item px-0"
                :class="{ 'selected-collection': device === selectedDevice }"
                @click="selectDevice(device)"
              >
                <div v-if="selectedDevice"
                  class="media user-item px-0"
                  :class="{ 'selected-collection': device.toLowerCase().replace(/\s+/g, '') === selectedDevice.toLowerCase().replace(/\s+/g, '') }"
                >
                  <div class="avatar mr-3 d-flex pl-3 muted-text">
                    <i class="ri-device-fill" style="font-size: 14px"></i>
                  </div>
                  <div class="d-flex flex-column text-left pr-3 collection-info">
                    <h6 class="mb-0">{{ device }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="database-screen background-container">
          <router-view></router-view>
        </div>
      </b-row>
    </div>
  </template>

<script>
import { ref, onMounted, watch } from 'vue'
import { xray } from '../../../config/pluginInit'
import { useRouter, useRoute } from 'vue-router'

export default {
  mounted () {
    xray.index()
  },
  name: 'KneeSleevePreOrderSummary',
  setup (props, context) {
    const devices = ref(['Knee Sleeve'])
    const searchText = ref('')
    const selectedDevice = ref(null)
    const route = useRoute()
    const router = useRouter()

    onMounted(() => {
      // Split the path and take the necessary part for the device name
      const pathSegments = route.path.split('/')
      if (pathSegments[1] === 'preorders' && pathSegments.length > 2) {
        // Assuming the device name is always the second segment after 'preorders'
        selectedDevice.value = pathSegments[2].replace(/-/g, ' ') // Replace hyphens with spaces if necessary
      }
    })

    watch(route, () => {
      // Do the same split logic here
      const pathSegments = route.path.split('/')
      if (pathSegments[1] === 'preorders' && pathSegments.length > 2) {
        selectedDevice.value = pathSegments[2].replace(/-/g, ' ') // Replace hyphens with spaces if necessary
      } else {
        selectedDevice.value = null
      }
    })

    const selectDevice = (device) => {
      switch (device) {
        case 'Knee Sleeve':
          router.push({ name: 'admin.preordersTable' })
          break
      }
    }

    return {
      searchText,
      devices,
      selectedDevice,
      selectDevice
    }
  }
}
</script>

  <style scoped>
  .admin-home {
    padding: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .collections-selection {
    width: 15%;
    border-right: 1px solid var(--border-color);
    border-radius: 4px 0 0 4px !important;
  }

  .database-screen {
    width: 85%;
  }

  .icon-large {
    font-size: 3rem;
  }

  .container {
    background-color: white;
    font-size: 0.9rem;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 7px 0 0 7px !important;
  }

  .collections-list {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .search-input {
    height: 30px;
  }

  .search-icon {
    position: absolute;
    right: 25px;
    top: 50%;
    transform: translateY(-50%);
  }

  .user-item {
    cursor: pointer;
    color: grey;
    align-items: center;
    padding: 5px 0;
  }

  .user-item.selected-collection {
    color: black;
    background-color: var(--light-grey);
    border-radius: 7px;
    width: 100%;
  }

  .text-left {
    text-align: left;
  }

  .collection-info {
    flex: 1;
    min-width: 0;
    font-size: 14px;
  }
  </style>
